import create from "zustand";

export const loggedInUserStore = create((set) => ({
  loggedInUser: null,
  isLoading: false,
  isLoggedIn: false,

  setCurrentUser: (userInstance) => {
    set({ loggedInUser: userInstance, isLoggedIn: true });
  },

  logout: () => set({ loggedInUser: null, isLoggedIn: false }),

  setIsLoading: (value) => set({ isLoading: value }),

  updateCurrentUser: (userInstance) => {
    set({ loggedInUser: userInstance });
  },
}));
